mainApp.component('progressBarComp', {
    templateUrl: '/public/components/progress-bar.component.html',
    bindings: {
        progressId: '<',
        progressFinish: '&',
        progress: '=',
    },
    controller: ['$scope', '$state', 'IntervalService', function($scope, $state, IntervalService)
    {
        var ctrl = this;

        ctrl.$onInit = function(){
            IntervalService.dynamicInterval(ctrl.getProgress, $scope.$id, 'discoveryProgressBarProgress', true);
        }

        ctrl.$onDestroy = function(){
            IntervalService.cancelDynamicInterval($scope.$id, 'discoveryProgressBarProgress');
        }

        ctrl.getProgress = function () {
            store.fetch({
                path: '/progress',
                queryParams: { id: ctrl.progressId },
                success: function (data) {
                    ctrl.progress = data;
                    if (!ctrl.progress || ctrl.progress.progress === 100 || ctrl.progress.status === 'ERROR') {
                        IntervalService.cancelDynamicInterval($scope.$id, 'discoveryProgressBarProgress');
                        if(data){
                            $scope.$root.handleServerResponse(data, "", "");
                        }
                        if (ctrl.progressFinish)
                            ctrl.progressFinish({data: ctrl.progress});
                    }
                },
            });
        };
    }]
});
